import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute-top-left container q-py-md",
  style: {"z-index":"10"}
}
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "q-pt-md header__fix" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "q-mt-md" }
const _hoisted_6 = { class: "row q-col-gutter-lg" }
const _hoisted_7 = {
  key: 0,
  class: "col-12"
}
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "flex q-gutter-md" }
const _hoisted_10 = {
  key: 1,
  class: "col-12"
}
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { style: {"font-weight":"unset","font-size":"1rem","line-height":"21px"} }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "container" }
const _hoisted_17 = { class: "container" }

import {computed, ref} from 'vue';
import {onlyUnique, truncate, truncateByWordAndCharacter} from 'src/etc/utils';
import {useRoute, useRouter} from 'vue-router';
import {Business} from 'src/models/business.model';
import ProfileAvatarHeader from 'src/components/profile/ProfileAvatarHeader.vue';
import BusinessProfileActionBtns from 'src/components/business/BusinessProfileActionBtns.vue';
import LocationsTabPanel from 'pages/business/businessPublicPage/LocationsTabPanel.vue';
import InfoTabPanel from 'pages/business/businessPublicPage/InfoTabPanel.vue';
import AdvertsTabPanel from 'pages/business/businessPublicPage/AdvertsTabPanel.vue';
import {useMeta, useQuasar} from 'quasar';
import {Advert} from 'src/models/advert';
import DetailHeaderGallery from 'src/apps/adverts/components/DetailHeaderGallery.vue';
import GoogleReviewWidget from 'src/etc/components/GoogleReviewWidget.vue';
import GalleryModal from 'components/qutils/GalleryModal.vue';
import CustomLink from 'components/etc/CustomLink.vue';
import ServiceTabPanel from 'pages/business/businessPublicPage/ServiceTabPanel.vue';



import {useMainStore} from 'stores/main';

const __default__ = {
  async preFetch({store, currentRoute, redirect, urlPath}) {
    const mainStore = useMainStore(store)
    const slug = currentRoute.params.slug.toString()
    await mainStore.fetchBusinessFirstPageAdverts(slug)

    return mainStore.fetchBusinessPublicAccount(slug).catch(err => {
      const {response} = err
      if (response?.data?.detail == 'not active') {
        mainStore.businessProfiles[slug] = {inactive: true}
        return err
      }
      if ([404, 400].includes(response?.status)) {
        redirect({name: '404', query: {url: urlPath}})
      }
      return err
    })
  }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BusinessPublicPage',
  setup(__props) {


const mainStore = useMainStore()
const route = useRoute()
const router = useRouter()
const slug = route.params.slug.toString()
const $q = useQuasar()
const aboutUsShowMore = ref(false)

const business = computed<Business>(() => {
  return mainStore.businessPublicProfiles[slug]
})
const tab = ref<'adverts' | 'info' | 'about' | 'locations'>(business.value?.adverts_num ? 'adverts' : 'info')


const businessLocations = computed(() => {
  if (!business.value?.locations?.length) return []
  const locationCities = business.value?.locations.flatMap(obj => obj.city)
  return locationCities.filter(onlyUnique);
})

const parsedImages = computed(() => {
  if (!business.value?.images_all) {
    return [];
  }
  return business.value.images_all.flatMap((obj) => {
    return {
      file: obj.image?.path,
      thumb: obj.image_thumbnail?.path ?? obj.image?.path,
    };
  });
});

function openGallery(position) {
  $q.dialog({
    component: GalleryModal,
    componentProps: {
      images: parsedImages.value,
      position
    },
  })
}


const images = computed(() => {
  return business.value?.images_all?.flatMap(img => {
    return {path: img.image?.path}
  }) || []
})

const hasHistory = computed(() => {
  return window && window.history?.length > 0 && window.history.state?.back !== null
})


const getJsonLd = function (business: Business) {
  if (!business) return {};
  const link = router.resolve({
    name: 'business-profile',
    params: {slug: business.slug},
  }).fullPath

  let lastAdverts: Array<Advert> = mainStore.businessFirstPageAdverts[slug] as any
  let adverts: Array<object> = []
  let services: Array<object> = []

  if (business.services) {
    for (let service of business.services) {
      services.push({
        '@type': 'Offer',
        'itemOffered': {
          '@type': 'Service',
          'name': service['name']
        }
      },)
    }
  }

  for (let advert of lastAdverts) {
    adverts.push({
      '@type': 'Offer',
      'itemOffered': {
        '@type': 'Vehicle',
        'name': `${advert.seo_title}`,
        'modelDate': advert.vehicle.year ? new Date(advert.vehicle.year, 0, 15).toISOString() : undefined,
        'color': advert.vehicle.equipment?.color_display,
        'url': router.resolve({
          name: 'listingDetail',
          params: {slug: advert.seo_slug, uuid: advert.uuid},
        }).fullPath,
        'offers': {
          '@type': 'AggregateOffer',
          'offerCount': 1,
          'lowPrice': advert.price,
          'highPrice': advert.price,
          'priceCurrency': 'EUR'
        }
      },
      'price': `${advert.price}`,
      'priceCurrency': 'EUR'
    })
  }

  // TODO: change accordingly
  const businessTypes = [
    'AutoDealer'
  ]

  const brands = lastAdverts.flatMap(obj => obj.vehicle.brand_display)

  return {
    business: {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': businessTypes,
        'name': `${business.public_name}`,
        'description': `${business.about_us_clean || ''}`,

        'address': {
          '@type': 'PostalAddress',
          'streetAddress': `${business.address?.street_and_number || ''}`,
          'addressLocality': `${business.address?.city || ''}`,
          'postalCode': `${business.address?.zip_code || ''}`,
          'addressCountry': `${business.address?.country_display || ''}`
        },
        contactPoint: [
          {
            '@type': 'ContactPoint',
            'name': `${business.public_name}`,
            'email': business.email,
            'contactType': 'customer support',
            'telephone': business.phone
          }
        ],
        'brand': brands,
        aggregateRating: {
          '@type': 'AggregateRating',
          'ratingValue': 5,
          'ratingCount': 1
        },
        'geo': {
          '@type': 'GeoCoordinates',
          'latitude': business.address?.latitude,
          'longitude': business.address?.longitude
        },
        'telephone': `${business.phone || ''}`,
        'email': `${business.email || ''}`,
        'url': link,
        'logo': `${business.avatar?.path || ''}`,
        'image': `${business.avatar?.path || ''}`,
        'priceRange': '$$',
        'makesOffer': adverts,
        'hasOfferCatalog': {
          '@type': 'OfferCatalog',
          'name': 'Services',
          'itemListElement': services
        }
      })
    }
  }
};

const setMeta = function () {
  const business: Business = mainStore.businessPublicProfiles[slug];

  if (!business || business?.is_active) return;

  useMeta(() => {
    const link = router.resolve({
      name: 'business-profile',
      params: {slug: business.slug},
    }).fullPath
    return {
      titleTemplate(title) {
        return `${business.public_name} | ${title}`;
      },

      // link: [{rel: 'canonical', href: canonical}],
      script: getJsonLd(business),

      link: {
        canonical: {
          rel: 'canonical',
          href: link,
        },
      },

      meta: {
        equiv: {
          'http-equiv': 'Content-Type',
          content: 'text/html; charset=UTF-8',
        },

        description: {
          name: 'description',
          template() {
            return `${truncate(business.about_us_clean, 147) || undefined}`;
          },
        },
        ogType: {
          property: 'og:type',
          template() {
            return 'og:profile';
          },
        },

        // note: for Open Graph type metadata you will need to use SSR, to ensure page is rendered by the server
        ogTitle: {
          property: 'og:title',

          // optional; similar to titleTemplate, but allows templating with other meta properties
          template() {
            return `${business.public_name || ''} auf Camper Trader`;
          },
        },
        ogDescription: {
          property: 'og:description',
          template() {
            return `${business.about_us_clean || ''}`;
          },
        },

        ogUrl: {
          property: 'og:url',
          template() {
            return `${link}`;
          },
        },

        ogImage: {
          property: 'og:image',
          template() {
            return `${business.avatar?.path}`;
          },
        },

        ogImageUrl: {
          property: 'og:image:url',
          template() {
            return `${business.avatar?.path}`;
          },
        },

        ogImageType: {
          property: 'og:image:type',
          template() {
            return 'image/jpeg';
          },
        },

        ogRich_attachment: {
          property: 'og:rich_attachment',
          template() {
            return true;
          },
        },

        ogImageAlt: {
          property: 'og:image:alt',
          template() {
            return `${business.public_name || ''} auf Camper Trader`;
          },
        },

        ogImageWidth: {
          property: 'og:image:width',
          template() {
            return '200';
          },
        },
        ogImageHeight: {
          property: 'og:image:height',
          template() {
            return '200';
          },
        },

        twitterImage: {
          property: 'twitter:image',
          template() {
            return `${business.avatar?.path}`;
          },
        },
        twitterCard: {
          property: 'twitter:card',
          template() {
            return 'summary_large_image';
          },
        },
        twitterSite: {
          property: 'twitter:site',
          template() {
            return '@CamperTrader_de';
          },
        },
        twitterCreator: {
          property: 'twitter:creator',
          template() {
            return '@CamperTrader_de';
          },
        },
        twitterTitle: {
          property: 'twitter:title',
          template() {
            return `${business.public_name || ''} auf Camper Trader`;
          },
        },
        twitterDescription: {
          property: 'twitter:description',
          template() {
            return `${business.about_us_clean || ''}`;
          },
        },
      },
    } as object;
  });
};

setMeta()



return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        class: _normalizeClass([{ container: !_unref($q).screen.lt.sm }, "relative-position"])
      }, [
        (_unref($q).screen.lt.sm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_q_btn, {
                    round: "",
                    color: "white",
                    "text-color": "dark",
                    size: "0.65rem",
                    icon: "fas fa-angle-left",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (hasHistory.value ? _ctx.$router.go(-1) : _ctx.$router.push({name: 'search', query: {t: 'dealer'}})))
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(DetailHeaderGallery, {
          images: images.value,
          onOpenGallery: _cache[1] || (_cache[1] = pos => openGallery(pos))
        }, null, 8, ["images"])
      ], 2),
      _createElementVNode("section", null, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ProfileAvatarHeader, { owner: business.value }, {
            buttons: _withCtx(() => [
              _createVNode(BusinessProfileActionBtns, { business: business.value }, null, 8, ["business"])
            ]),
            _: 1
          }, 8, ["owner"])
        ])
      ]),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (business.value.address?.place_details?.rating)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createVNode(CustomLink, {
                        rel: "external nofollow noreferrer noopener",
                        "no-link": !business.value.address?.place_details?.place_id,
                        href: `https://www.google.com/maps/place/?q=place_id:${business.value.address?.place_details.place_id}`,
                        target: "_blank",
                        style: {"text-decoration":"unset"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(GoogleReviewWidget, {
                            size: "sm",
                            rating: business.value.address?.place_details?.rating,
                            "user-ratings-total": business.value.address?.place_details?.user_ratings_total
                          }, null, 8, ["rating", "user-ratings-total"])
                        ]),
                        _: 1
                      }, 8, ["no-link", "href"])
                    ]),
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessLocations.value, (loc) => {
                        return (_openBlock(), _createBlock(_component_q_chip, {
                          key: loc,
                          clickable: "",
                          outline: "",
                          icon: "fas fa-location-dot",
                          size: "md",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (tab.value = 'locations'))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(loc), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (business.value?.about_us)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h1", _hoisted_12, [
                    (!aboutUsShowMore.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(truncateByWordAndCharacter)(business.value.about_us, 180)) + " ", 1),
                          _createElementVNode("a", {
                            href: "",
                            "data-nosnippet": "",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (aboutUsShowMore.value = true), ["prevent"]))
                          }, _toDisplayString(business.value.about_us.length > 180 ? 'mehr anzeigen' : undefined), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(business.value.about_us) + " ", 1),
                          _createElementVNode("a", {
                            href: "",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (aboutUsShowMore.value = false), ["prevent"]))
                          }, "weniger anzeigen")
                        ], 64))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: _normalizeClass({'container': _unref($q).screen.gt.xs})
            }, [
              _createVNode(_component_q_tabs, {
                modelValue: tab.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tab).value = $event)),
                breakpoint: 0,
                "active-color": "primary",
                align: "justify",
                "indicator-color": "primary",
                "inline-label": "",
                "no-caps": ""
              }, {
                default: _withCtx(() => [
                  (business.value.adverts_num > 0)
                    ? (_openBlock(), _createBlock(_component_q_tab, {
                        key: 0,
                        label: "Inserate",
                        name: "adverts"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_tab, {
                    label: "Info",
                    name: "info"
                  }),
                  (business.value.services?.length)
                    ? (_openBlock(), _createBlock(_component_q_tab, {
                        key: 1,
                        label: "Leistungen",
                        name: "services"
                      }))
                    : _createCommentVNode("", true),
                  (business.value.locations?.length)
                    ? (_openBlock(), _createBlock(_component_q_tab, {
                        key: 2,
                        label: "Standorte",
                        name: "locations"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 2),
            _createVNode(_component_q_tab_panels, {
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tab).value = $event)),
              "keep-alive": true,
              style: {"min-height":"35vh","background":"unset"}
            }, {
              default: _withCtx(() => [
                (business.value?.slug)
                  ? (_openBlock(), _createBlock(_component_q_tab_panel, {
                      key: 0,
                      class: "q-px-none",
                      name: "adverts",
                      style: {"overflow":"unset"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(AdvertsTabPanel, {
                            slug: business.value.slug
                          }, null, 8, ["slug"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_tab_panel, {
                  class: "q-my-md q-pa-none",
                  name: "info"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(InfoTabPanel, { business: business.value }, null, 8, ["business"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_tab_panel, {
                  class: "q-my-md q-pa-none",
                  name: "services"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(ServiceTabPanel, { business: business.value }, null, 8, ["business"])
                    ])
                  ]),
                  _: 1
                }),
                (business.value.locations?.length)
                  ? (_openBlock(), _createBlock(_component_q_tab_panel, {
                      key: 1,
                      class: "q-my-md q-pa-none",
                      name: "locations"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(LocationsTabPanel, { business: business.value }, null, 8, ["business"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})